<template>
  <div :class="computedClassName" :style="containerStyle">
    <div class="wrn-navbar-container wrn-container-fluid">
      <div :style="computedSlotContainerStyle" class="side wrn-text-left">
        <!-- @slot slot to be rendered on the left side -->
        <slot name="left" />
      </div>
      <div
        :style="computedSlotContainerStyle"
        class="center wrn-navbar-text wrn-text-center text-p6-semibold"
        data-e2e="navbar-title"
      >
        <!-- @slot slot to be rendered on the center -->
        <slot name="center" />
      </div>
      <div :style="computedSlotContainerStyle" class="side wrn-text-right">
        <!-- @slot slot to be rendered on the right side -->
        <slot name="right" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
/**
 * @deprecated - use Nebraska NavBar instead
 */
export default class NavBar extends Vue {
  /** Color to be rendered as background */
  @Prop({ type: String, required: false })
  private background?: string;

  @Prop({ type: String, required: false })
  private contentZIndex?: string;

  @Prop({ type: Object, default: () => ({}) })
  private containerStyle!: any;

  private created() {
    console.warn(
      'Using deprecated NavBar, please use Nebraska NavBar instead.'
    );
  }

  private get computedSlotContainerStyle() {
    return {
      'z-index': this.contentZIndex
    };
  }

  private get computedClassName() {
    let backgroundClass = 'custom-nav-bar';
    if (this.background) {
      if (this.background === 'transparent') {
        backgroundClass = 'trasparent';
      } else {
        backgroundClass = `wrn-bg-${this.background}`;
      }
    }

    return ['wrn-navbar', backgroundClass];
  }
}
</script>

<style lang="less" scoped>
.wrn-navbar-container {
  display: flex;
  align-items: center;
}

.wrn-navbar {
  display: flex;
  align-items: center;
  padding-top: 0;
}

.wrn-bg-black {
  background-color: @background-primary;
}

.wrn-navbar-container {
  display: flex;
  justify-content: space-between;

  /* To override existent styles */
  width: 100%;
  height: 100%;
}

.side {
  flex: 1 0 24px;
  white-space: nowrap;
}

.center {
  flex: 1 1 auto;
  padding: 0;
}

.transparent {
  background-color: #00000000;
}
</style>
